<script setup lang="ts">
import type { TasksKanbanCardAgentProps } from '../types/interfaces'

import { AppText } from '@shared/ui/typography'
import { KanbanDeadline } from '@shared/ui/kanban'

defineOptions({
  name: 'TasksKanbanCardAgent',
})

withDefaults(defineProps<TasksKanbanCardAgentProps>(), {
  agentName: null,
  deadline: null,
  expired: false,
  upcoming: false,
})
</script>

<template>
  <div class="task-card__agent-row">
    <AppText
      name="body2"
      color="slate-400"
      :class="['agent', { 'no-agent': !agentName }]"
    >
      {{ agentName ?? 'Unassigned agent' }}
    </AppText>
    <KanbanDeadline
      v-if="deadline"
      :value="deadline"
      :expired="expired"
      :upcoming="upcoming"
    />
  </div>
</template>

<style lang="scss" scoped src="../styles/_tasks-kanban-card-agent.scss" />
